import React from 'react';
import button from "bootstrap/js/src/button";
import ButtonCountCompClass from "./ButtonCountCompClass";
import ButtonInfoCompClass from "./ButtonInfoCompClass";
import URLCountCompClass from "./URLCountCompClass";
import URLFormClass from "./URLFormClass";
import ImageSelectModal from "../../../../../component/modal/ImageSelectModal";
import * as apiUtil from "../../../../../util/apiUtil";
import { Tooltip } from "@mui/material";
import ImageAddModal from "../../../image/component/ImageAddModal";
import SingleButton from "../../../../../component/button/SingleButton";
import * as dateUtil from "../../../../../util/dateUtil";
import Loading from "../../../../../component/loading/Loading";
import { rcsImageSizes, rcsSizeLabel, rcsImageSizeLimitLabel } from "../../../../../util/rcsTypeUtil";

class RCSFundamenFormClass extends React.Component {
    constructor(props) {
        super(props);

        this.handleContent = this.handleContent.bind(this);
        this.handleUrlCount = this.handleUrlCount.bind(this);
        this.handleButtonCount = this.handleButtonCount.bind(this);

        this.openImageListModal = this.openImageListModal.bind(this);
        this.closeImageListModal = this.closeImageListModal.bind(this);
        this.handleImageUploadModal = this.handleImageUploadModal.bind(this);
        this.checkFileName = this.checkFileName.bind(this);

        this.ajaxGetImageList = this.ajaxGetImageList.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);

        // AI 기능 관련 메서드 바인딩 추가
        this.setAIValue = this.setAIValue.bind(this);
        this.ajaxGenerateAIMessage = this.ajaxGenerateAIMessage.bind(this);
        this.ajaxCheckAIMessage = this.ajaxCheckAIMessage.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.handleReset = this.handleReset.bind(this);

        this.getButtonCountArray = this.getButtonCountArray.bind(this);

        // 자동 줄 추가
        this.msgTextareaRef = React.createRef();       // RCS 본문
        this.eventContentRef = React.createRef();      // 이벤트 내용
        this.eventWarningRef = React.createRef();      // 이벤트 유의사항

        this.fileInputRef = React.createRef();

        this.state = {
            buttonCount: [],
            imageListModal: false,
            imageUploadModal: false,

            imageList: [],
            page: 1,
            size: 10,
            sort: 'date',
            total: 0,

            rewardFormChecked: false,

            // AI 문구 생성 관련 상태 추가
            brandName: '',
            eventContent: '',
            eventFrom: dateUtil.dateToStr(new Date()),
            eventTo: dateUtil.dateToStr(new Date()),
            eventUrl: 'https://',
            eventWarning: '',
            customerCenter: '',
            loading: false,
        }// end state
    }// end constructor

    componentDidMount() {
        this.ajaxGetImageList();

        const defaultBrandName = this.getDefaultBrandName();
        if (defaultBrandName) {
            this.setState({ brandName: defaultBrandName });
        } else if (!this.state.brandName || this.state.brandName.trim() === "") {
            this.ajaxGetUserInfo();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.rcsType !== this.props.rcsType) {
            this.setState({ imageList: [], imageListModal: false, imageUploadModal: false, page: 1 }, () => this.ajaxGetImageList());
        }
        const defaultBrandName = this.getDefaultBrandName();
        const prevDefaultBrandName = this.getDefaultBrandName(prevProps);
        if (defaultBrandName && defaultBrandName !== prevDefaultBrandName && defaultBrandName !== this.state.brandName) {
            this.setState({ brandName: defaultBrandName });
            return;
        }

        const prevRCSButtons = prevProps.RCSInfo?.[0]?.buttons?.list?.length ?? 0;
        const currentRCSButtons = this.props.RCSInfo?.[0]?.buttons?.list?.length ?? 0;

        // 1. 버튼 리스트 길이가 변경되었을 때
        if (prevRCSButtons !== currentRCSButtons) {
            this.setState({
                buttonCount: this.getButtonCountArray(currentRCSButtons)
            }, () => {
                requestAnimationFrame(() => {
                    this.adjustTextareaHeight(this.msgTextareaRef);
                });
            });
            return;
        }

        // 2. 메시지 내용(msg) 또는 리마인드 관련 상태가 변경되었을 때 (AI 문구 생성 후 포함)
        if (prevProps.isRemind !== this.props.isRemind
            || prevProps.isRemindText !== this.props.isRemindText
            || prevProps.RCSInfo?.[0]?.msg !== this.props.RCSInfo?.[0]?.msg) {

            // isRemind 초기화 로직 (필요하면 setState 호출)
            if ((prevProps.isRemind !== this.props.isRemind && !this.props.isRemind)
                || (prevProps.isRemindText !== this.props.isRemindText && !this.props.isRemindText)) {
                this.setState({
                    buttonCount: this.getButtonCountArray(0)
                });
            }
            requestAnimationFrame(() => {
                this.adjustTextareaHeight(this.msgTextareaRef);
            });
        }
    }

    getButtonCountArray(count) {
        if (count === 0) return [];
        if (count === 1) return [1];
        if (count === 2) return [1, 2];
        return Array.from({ length: count }, (_, i) => i + 1); // 3개 이상일 때도 안전하게
    }

    getDefaultBrandName(props = this.props) {
        if (props.selectedTgtCompanyName) {
            return props.selectedTgtCompanyName;
        }
        if (props.companyList && props.companyList.length > 0) {
            return props.companyList[0].companyName;
        }
        return '';
    }

    handleUrlCount = (e) => {
        const { SelfAction, index, RCSInfo } = this.props;
        const { value } = e.target;
        const count = Number(value);

        // 기존 URL 배열 가져오기
        const prevUrls = RCSInfo[index].urlLink.list || [];

        // 새 URL 배열 만들기 (기존 값 유지, 부족한 부분만 'https://'로 채우기)
        let newUrls = prevUrls.slice(0, count); // 선택한 갯수만큼 자르기
        while (newUrls.length < count) {
            newUrls.push('https://');
        }

        // URL 개수 배열 (기존 방식 유지)
        let newUrlCount = [];
        for (let i = 1; i <= count; i++) newUrlCount.push(i);

        SelfAction.setUrlCount(newUrlCount);
        SelfAction.setRcsUrl(newUrls, index);
        SelfAction.setMmsUrl(newUrls);
    }// end handleUrl
    handleButtonCount(e) {
        const { value } = e.target;
        if (Number(value) === 0) this.setState({ buttonCount: [] });
        else if (Number(value) === 1) this.setState({ buttonCount: [1] });
        else if (Number(value) === 2) this.setState({ buttonCount: [1, 2] });
    }// end handlebuttonCount
    handleContent(e) {
        const { handleRCSInfoChange, aiState, onAIStateChange } = this.props;
        handleRCSInfoChange(e.target.name, e.target.value);

        onAIStateChange({
            aiGenerated: aiState.aiGenerated,
            isFirst: aiState.isFirst,
            isChanged: true
        });

        if (e.target.name === 'msg') {
            this.adjustTextareaHeight(this.msgTextareaRef);
        }
    }// RCS제목, 내용


    // 2026-03-18 fix: {…this.state} 스프레드 제거 - Safari 무한 로딩 버그 수정
    closeImageListModal() { this.setState({ imageListModal: false }) }
    openImageListModal() { this.setState({ imageListModal: true }, () => this.ajaxGetImageList()) }

    handleImageUploadModal() {
        const { imageUploadModal } = this.state;
        this.setState({ imageUploadModal: !imageUploadModal })
    }

    checkFileName() {
        const { imgName } = this.props;
        if (!imgName) {
            alert('이미지명이 입력되지 않았습니다.');
            return false;
        }

        this.handleImageUploadModal();
        return true;
    }

    clearFileInput() {
        // this.fileInputRef.current.value = '';
    }// end clearfileinput

    ajaxGetImageList() {
        const { page, size, sort } = this.state;
        const requestType = this.props.rcsType;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/image/list",
            method: apiUtil.requestMethod.POST,
            data: {
                imgType: "RCS",
                sizes: rcsImageSizes(this.props.rcsType),
                rcsType: Number(this.props.rcsType),
                sort: sort,
                page: page,
                size: size,
            },
            success: async (result) => {
                if (this.props.rcsType !== requestType || this.state.page !== page) return;
                await this.setState({ imageList: result.content, total: result.total });
            }
        })
    }// end ajaxGetImageList
    handlePageChange(value) {
        this.setState({ page: value }, () => this.ajaxGetImageList());
    }

    // AI 문구 생성 관련 메서드 추가
    setAIValue(e) {
        const { id, value } = e.target;
        if (id === 'brandName' && this.props.onTgtCompanyNameChange) {
            this.props.onTgtCompanyNameChange(value);
        }
        this.setState({ [id]: value }, () => {
            // 각 textarea에 맞는 ref 사용
            if (id === 'eventContent') this.adjustTextareaHeight(this.eventContentRef);
            else if (id === 'eventWarning') this.adjustTextareaHeight(this.eventWarningRef);
        });
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    // AI 문구 생성 API 호출 및 결과 적용
    ajaxGenerateAIMessage = () => {
        const { index, SelfAction, setMessage, onAICheckChange } = this.props;
        const { brandName, eventContent, eventFrom, eventTo, eventUrl, eventWarning, customerCenter, isFirst, isChanged } = this.state;

        const fields = {
            "업체명": brandName,
            "이벤트 내용": eventContent,
            "이벤트 시작일": eventFrom,
            "이벤트 종료일": eventTo,
            "고객센터": customerCenter
        };

        // 비어있는 필드 필터링
        const emptyKeys = Object.keys(fields).filter(key => {
            const val = fields[key];
            // if(key === '이벤트 URL') {
            //     return val === null || val === undefined || val === '' || val === 'http://' || val === 'https://';
            // }

            return val === null || val === undefined || (typeof val === "string" && val.trim() === "");
        });

        if (emptyKeys.length > 0) {
            alert(emptyKeys.join(", ") + " 이(가) 비어 있습니다.\n" +
                "필수 기입 사항이 누락되진 않았는지 재확인 부탁드립니다.\n");
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/ai/generate",
            method: apiUtil.requestMethod.POST,
            data: {
                brandName: brandName ? "브랜드명:" + brandName : null,
                eventContent: eventContent ? "이벤트 내용:" + eventContent : null,
                eventPeriod: (eventFrom && eventTo) ? "이벤트 기간: " + eventFrom + " ~ " + eventTo : null,
                eventUrl: eventUrl ? "이벤트 URL:" + eventUrl : null,
                eventWarning: eventWarning ? "이벤트 유의사항:" + eventWarning : null,
                customerCenter: customerCenter ? "고객센터:" + customerCenter : null,
            },
            success: async (result) => {
                // API 호출 성공 시, 제목과 본문 내용을 해당 textarea에 적용
                setMessage(result.title, result.body);
                this.props.onAIStateChange({
                    aiGenerated: true,
                    isFirst: false,
                    isChanged: true
                });

                if (onAICheckChange) {
                    onAICheckChange(true);
                }
            }
        });
    };

    handleReset() {
        // 부모 메서드 실행
        this.props.resetMessage();
        const { onAICheckChange } = this.props;
        const { brandName } = this.state;

        if (onAICheckChange) onAICheckChange(false);

        // aiGenerated 다시 false로
        this.setState({ aiGenerated: false, brandName: brandName }, () => {
            requestAnimationFrame(() => {
                this.adjustTextareaHeight(this.msgTextareaRef);
            });
        });
    }

    // AI 문구 검수 함수 추가
    ajaxCheckAIMessage = () => {
        const { index, RCSInfo, setMessage, onAICheckChange } = this.props;
        const { title, msg } = RCSInfo[index];
        const { isFirst, isChanged } = this.state;


        if (!title && !msg) {
            alert("검수할 제목 또는 내용이 없습니다.");
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/ai/check",
            method: apiUtil.requestMethod.POST,
            data: {
                inputTitle: title,
                inputBody: msg,
            },
            success: async (result) => {
                const newRCSInfo = [...RCSInfo];
                newRCSInfo[index] = {
                    ...newRCSInfo[index],
                    title: result.title,
                    msg: result.body,
                };

                setMessage(result.title, result.body);

                if (onAICheckChange) {
                    onAICheckChange(true); // 검수 완료로 상태 변경
                }

                this.props.onAIStateChange({
                    aiGenerated: true,
                    isFirst: false,
                    isChanged: false
                });

                // API 호출 성공 후 높이 조절 로직 추가
                requestAnimationFrame(() => {
                    this.adjustTextareaHeight(this.msgTextareaRef);
                });
            },
            error: (error) => {
                alert("검수 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.");
            }
        });
    };

    adjustTextareaHeight = (textareaRef) => {
        if (!textareaRef.current) return;
        const textarea = textareaRef.current;

        // 1. 높이 초기화
        textarea.style.height = 'auto';

        // 2. 최소 높이 계산 (예: 15줄)
        const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 3);
        const minHeight = lineHeight * 15;

        // 3. 스크롤 여부 확인
        if (textarea.scrollHeight > textarea.clientHeight) {
            // 내용이 더 많으면 scrollHeight 기준으로 높이 설정
            textarea.style.height = textarea.scrollHeight + 'px';
        } else {
            // 내용이 적으면 최소 높이
            textarea.style.height = Math.max(minHeight, textarea.scrollHeight) + 'px';
        }
    }

    ajaxGetUserInfo() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/info",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                this.setState({ brandName: result.comName });
            }
        })
    }

    render() {
        // 여기서 사용되는 index 는 RCSInfo (type : [])의 몇번째 정보인지를 불러오는 값
        const { RCSType, index, RCSInfo, SelfAction, urlCount, setUrlValue, changePreview, aiState } = this.props;

        const { loading, aiGenerated } = this.state;

        const { imgName, setCPValue, isRemind, isRemindText, handleRemindModal, resetRemindMessage } = this.props;
        const { checkFileName } = this;

        // AI 문구 생성 관련 상태와 메서드를 render 함수에서 비구조화 할당
        const { handleContent, handleButtonCount, handleUrlCount, openImageListModal, closeImageListModal, handleImageUploadModal, handlePageChange, ajaxGenerateAIMessage, setAIValue, ajaxCheckAIMessage, handleReset } = this;
        const { buttonCount, imageListModal, imageUploadModal, imageList, total, size, page, brandName, eventContent, eventFrom, eventTo, eventUrl, eventWarning, customerCenter } = this.state;

        const { aiCreated, resetMessage, aiMessageModify } = this.props;

        const titleLimit = (isRemind || isRemindText) ? 30 : 24;

        return (
            <div>
                {/*화면설계도 21페이지 1번에 해당하는 미리보기 영역*/}
                {/*입력하는 부분에 보여지는 부분 아직 구현 X*/}
                <Loading loading={loading} />
                <div className="pb-3 pt-2">
                    <div className="d-flex align-items-center mb-2">
                        <h5 className="mb-0 me-2">메시지<span className='text-danger'>*</span></h5>
                    </div>

                    {aiState.aiGenerated &&
                        <div className='p-2 mb-3 rounded-2 bg-light border'>
                            {/*3b에 해당하는 RCS제목에 해당하는 내용*/}
                            <div className="d-flex justify-content-between align-items-center">
                                <label>제목</label>
                                <button className="btn btn-light btn-sm d-flex align-items-center mb-1" onClick={() => isRemind ? resetRemindMessage() : this.handleReset()} style={{ backgroundColor: "#E9ECEF" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                                    </svg>
                                    {isRemind ? '캠페인 초기화' : '문구 다시 생성하기'}
                                </button>
                            </div>

                            <input
                                className="form-control"
                                type="text"
                                name="title"
                                onChange={handleContent}
                                value={RCSInfo?.[index]?.title ?? ''}
                                // readOnly={aiCreated}
                                readOnly={isRemind}
                                // onClick={aiMessageModify}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                                disabled={isRemind}
                            />
                            <p className={"text-end mb-0 fs-6 fw-light"}> (
                                <span style={{ color: (RCSInfo?.[index]?.title?.length ?? 0) > titleLimit ? 'red' : 'inherit' }}>
                                    {RCSInfo?.[index]?.title?.length ?? 0}
                                </span> / {titleLimit})
                            </p>

                            {/*3c에 해당하는 RCS내용*/}
                            <label>내용</label>
                            <textarea
                                name="msg"
                                className="form-control no-scrollbar no-resize"
                                rows="15"
                                onChange={handleContent}
                                value={RCSInfo?.[index]?.msg ?? ''}
                                readOnly={isRemind}
                                placeholder={"하단의 'AI문구 생성/검수' 버튼을 통해 메시지를 쉽게 작성해보세요.\n" +
                                    "작성 전 상단의 제작가이드를 반드시 확인 부탁드리며, 가이드 미 준수 시 메시지 문구가 반려될 수 있습니다."}
                                // readOnly={aiCreated}
                                // onClick={aiMessageModify}
                                ref={this.msgTextareaRef}
                                disabled={isRemind}
                            >
                            </textarea>
                            <p className={"text-end mb-0 fs-6 fw-light"}>
                                <span style={{ color: RCSInfo?.[index]?.msg?.length > 850 ? 'red' : 'inherit' }}>
                                    {RCSInfo?.[index]?.msg?.length ?? 0}
                                </span> / 850
                            </p>
                            {!isRemind &&
                                <div className="d-flex justify-content-end mt-3">
                                    <SingleButton
                                        className="btn btn-secondary"
                                        label="AI 문구 검수하기"
                                        handleClick={ajaxCheckAIMessage}
                                    />
                                </div>
                            }
                        </div>

                    }

                    {/* AI 문구 생성 */}
                    {!aiState.aiGenerated &&
                        <div className='p-2 mb-3 rounded-2 bg-light border'>
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="mb-2">AI 문구 생성</h5>
                                {isRemind !== true &&
                                    <button onClick={() => handleRemindModal(true)}
                                        className={"ms-2 btn btn-outline-primary btn-sm d-flex align-items-center"}>
                                        <span>이전 캠페인 불러오기 </span>
                                    </button>
                                }
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <label>업체 명</label>
                                    {this.props.companyList && this.props.companyList.length > 1 ? (
                                        <select
                                            id="brandName"
                                            className="form-select mb-2"
                                            value={brandName}
                                            onChange={setAIValue}
                                        >
                                            {this.props.companyList.map((company) => (
                                                <option key={company.uid || company.companyName} value={company.companyName}>
                                                    {company.companyName}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type="text"
                                            id="brandName"
                                            className="form-control mb-2 bg-light"
                                            placeholder="업체 명"
                                            value={brandName}
                                            readOnly={true}
                                        />
                                    )}
                                    <label>이벤트 내용</label>
                                    <textarea
                                        id="eventContent"
                                        className="form-control mb-2 no-scrollbar no-resize"
                                        rows="3"
                                        placeholder="메시지 발송 이벤트 내용을 입력해 주세요. (ex. 신규가입 고객 대상 무료쿠폰 지급)"
                                        value={eventContent}
                                        onChange={setAIValue}
                                        ref={this.eventContentRef}
                                    >
                                    </textarea>
                                    <label>이벤트 기간</label>
                                    <div className="d-flex mb-2">
                                        <input
                                            type="date"
                                            id="eventFrom"
                                            className="form-control"
                                            value={eventFrom}
                                            onChange={setAIValue}
                                        />
                                        <span className="p-2">~</span>
                                        <input
                                            type="date"
                                            id="eventTo"
                                            className="form-control"
                                            value={eventTo}
                                            onChange={setAIValue}
                                        />
                                    </div>
                                    <label>이벤트 URL </label>
                                    <span style={{
                                        display: 'block', fontSize: '0.7rem',   // 글자 크기 더 작게
                                        color: '#6c757d',     // Bootstrap text-muted 색상
                                        marginBottom: '0.25rem'
                                    }}>
                                        URL은 3개까지 입력 가능하며, 콤마(,)로 구분하여 작성해 주세요
                                    </span>
                                    <input
                                        type="text"
                                        id="eventUrl"
                                        className="form-control mb-2"
                                        placeholder="이벤트 URL을 입력해 주세요."
                                        value={eventUrl}
                                        onChange={setAIValue}
                                    />
                                    <label>이벤트 유의사항</label>
                                    <textarea
                                        id="eventWarning"
                                        className="form-control mb-2 no-scrollbar no-resize"
                                        rows="3"
                                        placeholder="이벤트 유의사항을 입력해 주세요."
                                        value={eventWarning}
                                        onChange={setAIValue}
                                        ref={this.eventWarningRef}
                                    >
                                    </textarea>
                                    <label>고객센터</label>
                                    <input
                                        type="text"
                                        id="customerCenter"
                                        className="form-control mb-2"
                                        placeholder="고객센터 정보를 입력해 주세요. (ex. 1688-3764)"
                                        value={customerCenter}
                                        onChange={setAIValue}
                                    />
                                    <div className="d-flex justify-content-end mt-3">
                                        <SingleButton
                                            className="btn btn-primary me-2"
                                            label="AI 문구 생성"
                                            handleClick={ajaxGenerateAIMessage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {/* 설문 선택 UI - 운영상 숨김 처리 */}
                    <div className="pb-3">
                        <h5 className="">설문</h5>
                        <div className="d-flex align-items-center mb-2">
                            <div className="form-check me-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="isFormAdded"
                                    id="formNone"
                                    value="N"
                                    checked={this.props.isFormAdded === 'N'}
                                    onChange={(e) => this.props.handleFormChange(e.target.name, e.target.value)}
                                    disabled={isRemind}
                                />
                                <label className="form-check-label" htmlFor="formNone">
                                    없음
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="isFormAdded"
                                    id="formAdd"
                                    value="Y"
                                    checked={this.props.isFormAdded === 'Y'}
                                    onChange={(e) => this.props.handleFormChange(e.target.name, e.target.value)}
                                    disabled={isRemind}
                                />
                                <label className="form-check-label" htmlFor="formAdd">
                                    추가
                                </label>
                            </div>
                        </div>
                        {this.props.isFormAdded === 'Y' && (
                            <div className="mb-2">
                                <select
                                    className="form-select" // w-auto 제거하여 전체 너비 사용하거나 필요시 조정
                                    name="selectedFormUid"
                                    value={this.props.selectedFormUid}
                                    onChange={(e) => this.props.handleFormChange(e.target.name, e.target.value)}
                                    disabled={isRemind}
                                >
                                    <option value="">설문을 선택해주세요</option>
                                    {this.props.formList && this.props.formList.map((form) => (
                                        <option key={form.uid} value={form.uid}>
                                            {form.formTitle}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>

                    {/* 네이버 로그인 — 네이버 로그인 플러스 앱이 있는 회원만 노출 */}
                    {this.props.hasNaverApp && (
                    <div className="pb-3">
                        <h5 className="">N-PASS</h5>
                        <div className="d-flex align-items-center mb-2">
                            <div className="form-check me-3">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="isNaverLoginAdded"
                                    id="naverLoginNone"
                                    value="N"
                                    checked={this.props.isNaverLoginAdded === 'N'}
                                    onChange={(e) => this.props.handleNaverLoginChange(e.target.name, e.target.value)}
                                    disabled={isRemind}
                                />
                                <label className="form-check-label" htmlFor="naverLoginNone">
                                    없음
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="isNaverLoginAdded"
                                    id="naverLoginUse"
                                    value="Y"
                                    checked={this.props.isNaverLoginAdded === 'Y'}
                                    onChange={(e) => this.props.handleNaverLoginChange(e.target.name, e.target.value)}
                                    disabled={isRemind}
                                />
                                <label className="form-check-label" htmlFor="naverLoginUse">
                                    사용
                                </label>
                            </div>
                        </div>
                        {this.props.isNaverLoginAdded === 'Y' && (
                            <div className="mb-2">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder="메시지에 표시할 문구를 입력해주세요 (예: 네이버로 간편 참여하기)"
                                    name="naverLoginText"
                                    value={this.props.naverLoginText}
                                    onChange={(e) => this.props.handleNaverLoginChange(e.target.name, e.target.value)}
                                />
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="로그인 완료 후 이동할 URL을 입력해주세요"
                                    name="naverRedirectUrl"
                                    value={this.props.naverRedirectUrl}
                                    onChange={(e) => this.props.handleNaverLoginChange(e.target.name, e.target.value)}
                                />
                            </div>
                        )}
                    </div>
                    )}

                    <div className={"pb-3"} style={{ display: 'none' }}>
                        <URLCountCompClass urlCount={urlCount} handleUrlCount={handleUrlCount} />
                        {/*disabled={aiCreated}*/}
                        <URLFormClass
                            // disabled={aiCreated}
                            urlCount={urlCount}
                            setUrlValue={setUrlValue}
                            data={RCSInfo[index].urlLink?.list}
                        />
                    </div>
                    <div className='pb-3'>
                        {!(isRemind && buttonCount.length === 0) &&
                            <Tooltip title={<p>버튼은 RCS 메시지에만 포함되어 발송 됩니다.</p>}>
                                <div className={"d-inline-flex align-items-center pointer me-2"}>
                                    <h5 className='d-inline-block mb-1 fs-5'>버튼</h5>
                                    <span className="material-symbols-rounded mb-2 fs-5 text-primary ms-1">info</span>
                                </div>
                            </Tooltip>
                        }
                        {!isRemind &&
                            <ButtonCountCompClass
                                index={index}
                                SelfAction={SelfAction}
                                handleButtonCount={handleButtonCount}
                                buttonCount={buttonCount}
                                buttons={RCSInfo?.[index]?.buttons?.list || []}
                            />
                        }

                        {/*ButtonCountComp를 통해 선택된 버튼이 몇개인지를 확인
                        갯수 만큼 버튼이 보여지게 구현
                        사용자가 button을 선택하지 않으면 보여지지 않게 구현*/}
                        {(
                            (!isRemind && Array.isArray(buttonCount) && buttonCount.length > 0) ||
                            (isRemind && Array.isArray(RCSInfo?.[index]?.buttons?.list) && RCSInfo[index].buttons.list.length > 0)
                        ) && (
                                <div className='table-responsive pt-2'>
                                    <table className="table table-hover align-middle fs-6">
                                        <thead>
                                            <tr className='table-light'>
                                                <th>NO</th>
                                                <th>타입</th>
                                                <th>버튼명</th>
                                                <th>버튼 링크</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(isRemind
                                                ? RCSInfo?.[index]?.buttons?.list
                                                : buttonCount
                                            )?.map((_, idx) => (
                                                <ButtonInfoCompClass
                                                    key={idx}
                                                    index={index}
                                                    buttonIndex={idx}
                                                    button={RCSInfo?.[index]?.buttons?.list?.[idx] || {}}
                                                    SelfAction={SelfAction}
                                                    isRemind={isRemind}
                                                />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                    </div>

                    {/*3e 에 해당하는 메인 이미지 관련 내용*/}
                    {
                        isRemind !== true && RCSType === "이미지" &&
                        <>
                            <h5>메인 이미지</h5>
                            <div className='file-upload-area'>
                                <div className="input-group">
                                    <button
                                        className="btn btn-sm btn-primary rounded d-flex align-items-center me-2"
                                        onClick={openImageListModal}
                                    >
                                        <span className="material-symbols-rounded fs-5 me-2">photo_library</span>불러오기
                                    </button>
                                    <button
                                        className="btn btn-sm btn-primary rounded d-flex align-items-center"
                                        onClick={handleImageUploadModal}
                                    >
                                        <span className="material-symbols-rounded fs-5 me-2">upload_file</span>업로드
                                    </button>
                                </div>
                                <p className='fs-6 fw-normal text-muted'>파일유형 : <strong>jpg/jpeg</strong> | {rcsSizeLabel(this.props.rcsType)}px ({rcsImageSizeLimitLabel(this.props.rcsType)})</p>
                            </div>
                        </>
                    }

                    {/*    <div className='pb-3'>*/}
                    {/*        <h5 className="">*/}
                    {/*            <input*/}
                    {/*                className="form-check-input ms-1 me-2 m-0"*/}
                    {/*                type="checkbox"*/}
                    {/*                name="useReward"*/}
                    {/*                onChange={(e) => setCPValue(e.target.name, e.target.checked)}*/}
                    {/*            />*/}
                    {/*            리워드*/}
                    {/*        </h5>*/}
                    {/*        <div className='pb-2'>*/}
                    {/*            <label className='me-2 fs-5 d-block '>URL</label>*/}
                    {/*            <select*/}
                    {/*                className='form-select d-inline me-2 w-auto'*/}
                    {/*                name="rewardUrl"*/}
                    {/*                onChange={(e) => setCPValue(e.target.name, e.target.value)}*/}
                    {/*            >*/}
                    {/*                <option value="" defaultChecked={true}>URL 선택</option>*/}
                    {/*                {*/}
                    {/*                    RCSInfo[index]?.urlLink?.list.map((item, index) => {*/}
                    {/*                        return <option key={index} value={index}>{item}</option>*/}
                    {/*                    })*/}
                    {/*                }*/}
                    {/*            </select>*/}
                    {/*        </div>*/}
                    {/*        <div className='pb-2'>*/}
                    {/*            <label className='me-2 fs-5 d-block'>포인트</label>*/}
                    {/*            <select*/}
                    {/*                className='form-select d-inline me-2 w-auto'*/}
                    {/*                name="rewardPoint"*/}
                    {/*                disabled*/}
                    {/*            >*/}
                    {/*                <option value="nPay" defaultChecked={true}>네이버 페이</option>*/}
                    {/*            </select>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}

                </div>
                <ImageSelectModal
                    key={this.props.rcsType}
                    clearFile={() => {
                        SelfAction.setRCSFile(index, null);
                        /*초기모델에만*/
                        SelfAction.setMMSFile(null);
                        this.clearFileInput();
                    }}
                    changePreview={changePreview}
                    SelfAction={SelfAction}
                    MTYPE={"RCS"}
                    isOpen={imageListModal}
                    isClose={closeImageListModal}
                    index={index}
                    handleChangePage={handlePageChange}
                    imageList={imageList}
                    total={total}
                    size={size}
                    page={page}
                />
                <ImageAddModal
                    key={this.props.rcsType}
                    rcsType={this.props.rcsType}
                    isOpen={imageUploadModal}
                    handleClose={handleImageUploadModal}
                    setValue={setCPValue}
                    imgUploadAction={checkFileName}
                    imgType="RCS"
                    imgName={imgName}
                />
            </div>

        )
    }// end render
}// end class

export default RCSFundamenFormClass;
